import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { DeleteCircle } from '@ringcentral/juno-icon';
import { styled } from '../../../../foundation';
import { RcIconButton } from '../../../Buttons/IconButton';
import { RcBox } from '../../../Box';
import { withTooltip } from '../../../Tooltip';
var FakeButton = styled(RcIconButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  right: 0;\n  pointer-events: none;\n"], ["\n  position: absolute;\n  right: 0;\n  pointer-events: none;\n"])));
var _ClearIconButton = forwardRef(function (_a, ref) {
    var onMouseDown = _a.onMouseDown, size = _a.size, iconSize = _a.iconSize, rest = __rest(_a, ["onMouseDown", "size", "iconSize"]);
    return (React.createElement(RcBox, { display: "inline-flex", alignItems: "center", position: "relative" },
        React.createElement(RcIconButton, __assign({ type: "button", "aria-hidden": true, variant: "plain", symbol: DeleteCircle, tabIndex: -1, 
            // * for prevent focus change
            onMouseDown: function (e) {
                e.preventDefault();
                onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
            }, size: size }, rest, { useRcTooltip: false })),
        React.createElement(FakeButton, { variant: "plain", as: "div", size: size, ref: ref })));
});
// TODO: fix this after upgarde ts
export var ClearIconButton = styled(withTooltip(_ClearIconButton))(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  position: relative;\n"], ["\n  display: flex;\n  align-items: center;\n  position: relative;\n"])));
ClearIconButton.defaultProps = { useRcTooltip: true };
var templateObject_1, templateObject_2;
